import React from 'react'

import { Heading4, Body3, Space } from '@gousto-internal/citrus-react'

import { sanitize } from 'utils/sanitizer'

type AllergensProps = {
  labelHtml?: string
  disclaimerHtml?: string
}

export const Allergens = ({ labelHtml, disclaimerHtml }: AllergensProps) => {
  if (!labelHtml && !disclaimerHtml) return null

  return (
    <>
      <Heading4>Allergens</Heading4>
      <Space size={4} />
      {labelHtml ? (
        <Body3 data-testing="allergen" dangerouslySetInnerHTML={{ __html: sanitize(labelHtml) }} />
      ) : null}
      {disclaimerHtml ? (
        <Body3
          data-testing="disclaimer-html"
          dangerouslySetInnerHTML={{ __html: sanitize(disclaimerHtml) }}
        />
      ) : null}
    </>
  )
}
